import { useMemo } from 'react'
import { number, string, oneOfType, object } from 'prop-types'
import { FieldGovernance } from './field-governace'

export const EditField = ({ fieldSetId, field = null, fieldId: _, ...rest }) => {
  const fieldWithDefaults = useMemo(
    () => ({
      ...field,
      invalidTypes: {
        ...(field?.invalidTypes || {}),
        pattern: true,
      },
    }),
    [field],
  )

  if (!fieldSetId) {
    return null
  }

  return <FieldGovernance {...rest} fieldSetId={fieldSetId} field={fieldWithDefaults} />
}

EditField.propTypes = {
  fieldSetId: string.isRequired,
  fieldId: oneOfType([string, number]).isRequired,
  field: object,
}
